var removeSpacesAndAccents = function removeSpacesAndAccents(value) {
  if (!value) {
    return '';
  }
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/gi, '');
};
export default removeSpacesAndAccents;